module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer",
    attrs: {
      "id": "applicationFooter"
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "col-md-12 bootomFooter"
  }, [(_vm.brand.toLowerCase() == 'cargill') ? _c('div', [_vm._v("© " + _vm._s(_vm.user_lang.copyrights) + "  "), _c('a', {
    attrs: {
      "href": _vm.user_lang.privacypolicy_link,
      "target": "_blank"
    }
  }, [_vm._v("\n\t\t  " + _vm._s(_vm.user_lang.privacypolicy))]), _vm._v("  |  "), _c('a', {
    attrs: {
      "href": _vm.user_lang.termsandconditions_link,
      "target": "_blank"
    }
  }, [_vm._v("\n\t\t  " + _vm._s(_vm.user_lang.termsandconditions))])]) : _vm._e(), _vm._v(" "), (_vm.brand.toLowerCase() !== 'cargill') ? _c('div', [_vm._v("© " + _vm._s(_vm.brand) + ", Incorporated. All Rights Reserved.  ")]) : _vm._e()])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6c07c36f", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c07c36f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer/footer.vue
// module id = 700
// module chunks = 1